import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithAuthCheck } from "../../utils/baseQueryWithAuthCheck";
import { endPoints, MIDDLEWARE_SLUG } from "../../apis/apiEndPoints";
import { extractDomain } from "../../utils/helpers";
import {
  ICampaignContactableDetails,
  ICampaignDraftDetails,
  ICampaignInitialDetails,
  IFaqDetails,
} from "../../types/campaign.types";

const DOMAIN = extractDomain();

export const whatsAppCampaignApi = createApi({
  reducerPath: "whatsAppCampaignApi",
  baseQuery: baseQueryWithAuthCheck(
    fetchBaseQuery({
      baseUrl: `${window.location.origin}${MIDDLEWARE_SLUG}/middleware`,
    })
  ),
  endpoints: (builder) => ({
    // to fetch initial details using initiationId - useGetCampaignInitialDetailsQuery
    getCampaignInitialDetails: builder.query<
      ICampaignInitialDetails,
      { initiationId: string }
    >({
      query: ({ initiationId }) => ({
        url: `${endPoints.SEARCH_ATTRIBUTES}?id=${initiationId}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // to fetch saved/draft details using campaignId - useGetCampaignDraftDetailsQuery
    getCampaignDraftDetails: builder.query<
      ICampaignDraftDetails,
      { campaignId: string }
    >({
      query: ({ campaignId }) => ({
        url: `${endPoints.GET_DRAFT_DETAILS}?campaignId=${campaignId}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // to fetch contactable candidate and folder details using initiationId - useGetCampaignContactableDetailsQuery
    getCampaignContactableDetails: builder.query<
      ICampaignContactableDetails,
      { initiationId: string }
    >({
      query: ({ initiationId }) => ({
        url: `${endPoints.CONTACTABLE_EMAILS_COUNT}/${initiationId}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // to fetch FAQ - useGetCampaignFaqDetailsQuery
    getCampaignFaqDetails: builder.query<IFaqDetails[], {}>({
      query: () => ({
        url: endPoints.WHATS_APP_FAQ,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

  }),
});

export const {
  useGetCampaignContactableDetailsQuery,
  useGetCampaignDraftDetailsQuery,
  useGetCampaignInitialDetailsQuery,
  useGetCampaignFaqDetailsQuery,
} = whatsAppCampaignApi;
